import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl, FormArray } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CredentialService } from 'src/app/services/core/credential/credential.service';
import { UserService } from 'src/app/services/core/users/user.service';
import { VarificationService } from 'src/app/services/core/varifications/varification.service';
import { companyVerificationLabels, onTimeChange, scrollToDocumentField } from 'src/app/utils/utils.common';
import * as moment from 'moment-timezone';
import { sweetAlert } from 'src/app/utils/swal';
import { SpaceTypeService } from 'src/app/services/core/spaceTypes/space-type.service';
import { ServiceAreasService } from 'src/app/services/core/service-areas-service/service-areas.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
import { OnboardingMenu } from 'src/app/enums/enums';
import { TitleCasePipe } from '@angular/common';
@UntilDestroy()

@Component({
  selector: 'app-company',
  templateUrl: './company.component.html',
  styleUrls: ['./company.component.css']
})
export class CompanyComponent implements OnInit,OnDestroy {
  companyId: any;
  titleCase = new TitleCasePipe();
  serviceAreas:any
  companyForm!: FormGroup;
  preServiceAreas:any;
  companyVarificationForm!: FormGroup;
  approvalForm! : FormGroup;
  submitted = false;
  users:any = [];
  companyData:any;
  isAllControlsTrue: boolean = false;
  serviceAreaName:any = [];
  showRejectReasonModal = false;
  rejectingDocumentLabel: string = '';
  rejectingSection: string = '';
  rejectingField: string = '';
  rejectingControlPath: string = '';
  rejectingGroupName: string = '';
  rejectingControlName: string = '';
  rejectedReasons: { [key: string]: string } = {};
  scrollToField: any;
  highlightStatus: any;
  sectionLabels: { [key: string]: string } = {
    owner: 'owner',
    documents: 'documents',
    insurance: 'insurance',
  };
  days = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday'
  ];

  constructor(
    private fb: FormBuilder,
    private credentialService: CredentialService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private verificationService: VarificationService,
    private userService: UserService,
    private spaceTypeService:SpaceTypeService,
    private serviceArea:ServiceAreasService,
    private sharedDataService: SharedDataService
  ) {}

  ngOnInit() {
    
    this.activatedRoute.params
      .pipe(untilDestroyed(this)).subscribe((params) => {
        this.companyId = params["companyId"];

      });

    this.companyForm = this.fb.group({
      name: [''],
      phoneNumber: [''],
      secondaryPhoneNumber: [''],
      hoursofOperation: this.fb.array([]),
      email: [''],
      timeZone: [''],
      profileImageURL: [''],
      webURL: [''],
      signup: [''],
      serviceAreas: [''],

      address: this.fb.group({
        name: [''],
        coords: [[]],
        city: [''],
        state: [''],
      }),

      owner: this.fb.group({
        firstName: [''],
        middleName: [''],
        lastName: [''],
        phoneNumber: [''],
        email: [''],
        driverLicenseImage: [''],

        address: this.fb.group({
          name: [''],
          coords: [[]],
          city: [''],
          state: ['']
        })
      }),

      documents: this.fb.group({
        hIPAATrainingCertificateImage: [''],
        hIPAATrainingDate: [''],
        hIPAATrainingExpireDate: [''],
        fraudWasteAndAbuseCertificateImage: [''],
        fraudWasteAndAbuseCertificateDate: [''],
        fraudWasteAndAbuseCertificateExpireDate: [''],
        nonDisclosureAgreementImage: [''],
        transportationProviderAgreementImage: [''],
        w9Image: [''],
        disclosureofOwnershipImage: [''],
        eFTFormImage: [''],
        voidedCheckImage: [''],
        driverScheduleImage: [''],
        vehicleScheduleImage: [''],
        vehicleForHireLicenseImage: [''],
      }),

      insurance: this.fb.group({
        generalLiabilityInsuranceImage: [''],
        generalLiabilityInsuranceDate: [''],
        generalLiabilityInsuranceExpireDate: [''],
        autoLiabilityInsuranceImage: [''],
        autoLiabilityInsuranceDate: [''],
        autoLiabilityInsuranceExpireDate: [''],
        workerCOIImage: [''],
        workerCOIImageExpireDate: [''],
      }),

      bankDetails: this.fb.group({
        name: [''],
        accountNumber: [''],
        routingNumber: [''],
      }),

      taxInformation: this.fb.group({
        name: [''],
        npi: [''],
        taxId: [''],
        taxonomy: [''],
      }),

      focalPersonInformation: this.fb.group({
        name: [''],
        email: [''],
        contactNumber: [''],
        phoneNumber: [''],
      }),
    });

    // .....
    this.companyVarificationForm = this.fb.group({
      isName: [false],
      isTimeZone: [false],
      isWebURL: [false],
      isProfileImageURL: [false],
      isPhoneNumber: [false],
      isSecondaryPhoneNumber: [false],
      isEmail: [false],
      isHoursofOperation: [false],
      isServiceAreas: [false],
      address: this.fb.group({
        isName: [false],
        isCity: [false],
        isState: [false],
      }),

      owner: this.fb.group({
        isFirstName: [false],
        isMiddleName: [false],
        isLastName: [false],
        isPhoneNumber: [false],
        isEmail: [false],
        isDriverLicenseImage: [false],
        address: this.fb.group({
          isName: [false],
          isCity: [false],
          isState: [false],
        })
      }),

      documents: this.fb.group({
        isHIPAATrainingCertificateImage: [false],
        isHIPAATrainingDate: [false],
        isHIPAATrainingExpireDate: [false],
        isFraudWasteAndAbuseCertificateImage: [false],
        isFraudWasteAndAbuseCertificateDate: [false],
        isFraudWasteAndAbuseCertificateExpireDate: [false],
        isNonDisclosureAgreementImage: [false],
        isTransportationProviderAgreementImage: [false],
        isW9Image: [false],
        isDisclosureofOwnershipImage: [false],
        isEFTFormImage: [false],
        isVoidedCheckImage: [false],
        isDriverScheduleImage: [false],
        isVehicleScheduleImage: [false],
        isVehicleForHireLicenseImage: [false]
      }),

      insurance: this.fb.group({
        isGeneralLiabilityInsuranceImage: [false],
        isGeneralLiabilityInsuranceDate: [false],
        isGeneralLiabilityInsuranceExpireDate: [false],
        isAutoLiabilityInsuranceImage: [false],
        isAutoLiabilityInsuranceDate: [false],
        isAutoLiabilityInsuranceExpireDate: [false],
        isWorkerCOIImage: [false],
        isWorkerCOIImageExpireDate: [false],
      }),

      bankDetails: this.fb.group({
        isName: [false],
        isAccountNumber: [false],
        isRoutingNumber: [false],
      }),

      taxInformation: this.fb.group({
        isName: [''],
        isNpi: [''],
        isTaxId: [''],
        isTaxonomy: [''],
      }),

      focalPersonInformation: this.fb.group({
        isName: [''],
        isEmail: [''],
        isContactNumber: [''],
        isPhoneNumber: [''],
      }),
    })

    this.approvalForm = this.fb.group({
      isApproved: [false, Validators.required],
      approvedDate: ['', Validators.required],
      user: ['', Validators.required],
    })
    this.getRedirectEntity();
    this.getUser();
    // this.getSpaceType() 
    this.getServiceAreas()
  }

  getUser() {
    this.sharedDataService
    .getUser()
    .pipe(untilDestroyed(this)).subscribe(user => {
      if (user) {
        this.approvalForm.patchValue({
          user: user.id
        });
      }
    });
  }

  getRedirectEntity() {
      this.sharedDataService
        .getOnboardingRedirectEntity()
        .pipe(untilDestroyed(this))
        .subscribe((redirect) => {
        if (redirect) {
          const {entity, entityType} = redirect;
          if (entity && entityType === OnboardingMenu.COMPANY) {
            this.companyId = entity.id;
            this.scrollToField = entity.documentType;
            this.highlightStatus = entity.documentStatus;
            this.operationsArray.clear();
            this.getCompanybyId();
            this.sharedDataService.setOnboardingRedirectEntity(null);
          }
        }
      });
    }

  loadOperationHours(operationHours?: any) {
    const items = this.companyForm.get('hoursofOperation') as FormArray;
    items.clear(); 
    if (operationHours && operationHours.length) {
      for (const day of operationHours) {
        items.push(
          this.fb.group({
            enabled: [{value: day.enabled, disabled: true}],
            startTime: [moment(day.startTime, "HH:mm").toISOString()],
            endTime: [moment(day.endTime, "HH:mm").toISOString()],
          })
        );
      }
    } else {
      for (let i = 0; i < this.days.length; i++) {
        items.push(
          this.fb.group({
            enabled: [{value:false, disabled: true}],
            startTime: [moment().startOf('day').toISOString()],
            endTime: [moment().endOf('day').toISOString()],
          })
        );
      }
    }
  }

  toggleDisApprovedReasonModal(show: boolean, documentLabel: string = '', groupName: string = '', controlName: string = '') {
    this.showRejectReasonModal = show;
    this.rejectingDocumentLabel = documentLabel;
    if (controlName) {
      const rawField = controlName.replace(/^is/, '');
      this.rejectingField = rawField.charAt(0).toLowerCase() + rawField.slice(1);
      this.rejectingSection = this.sectionLabels[groupName] ?? groupName;
      this.rejectingControlPath = groupName ? `${groupName}.${controlName}` : controlName;
      this.rejectingGroupName = groupName;
      this.rejectingControlName = controlName;
    }
  }

  onRejectReasonSubmit(reason: string) {
    if (!this.companyData) {
      return;
    }
    const payload = {
      section: this.rejectingSection,
      field: this.rejectingField,
      approved: false,
      reason,
    };
    this.verificationService.disApprovedCompanyField(this.companyId, payload).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        this.setControls(this.rejectingGroupName, this.rejectingControlName, false);
        this.rejectedReasons[this.rejectingControlPath] = reason;
        this.toggleDisApprovedReasonModal(false);
      }
    });
  }

  approveField(groupName: string, controlName: string) {
    if (!this.companyData) {
      return;
    }
    const rawField = controlName.replace(/^is/, '');
    const payload = {
      section: this.sectionLabels[groupName] ?? groupName,
      field: rawField.charAt(0).toLowerCase() + rawField.slice(1),
      approved: true,
      reason: '',
    };
    const path = groupName ? `${groupName}.${controlName}` : controlName;
    this.verificationService.disApprovedCompanyField(this.companyId, payload).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        this.setControls(groupName, controlName, true);
        delete this.rejectedReasons[path];
      }
    });
  }

  showRejectReason(rejectionReasons: any): { [key: string]: string } {
    const result: { [key: string]: string } = {};
    if (!rejectionReasons) {
      return result;
    }
    Object.keys(rejectionReasons).forEach((group) => {
      const fields = rejectionReasons[group] || {};
      Object.keys(fields).forEach((field) => {
        const controlName = 'is' + field.charAt(0).toUpperCase() + field.slice(1);
        const path = group ? `${group}.${controlName}` : controlName;
        result[path] = fields[field]?.reason;
      });
    });
    return result;
  }

  setControls(groupName: string, controlName: string, value: any) {
    const fullPath = groupName ? `${groupName}.${controlName}` : controlName;
    const control = this.companyVarificationForm.get(fullPath);
    if (control) {
      control.setValue(value);
      control.markAsTouched();
    }
  }

  getCompanybyId() {
    this.credentialService.getCompanyById(this.companyId).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        this.companyData = data
        this.rejectedReasons = this.showRejectReason(data.rejectionReasons);
        if(this.preServiceAreas){
          for (let item of this.companyData.serviceAreas) {
          if(this.preServiceAreas[item])
          this.serviceAreaName.push(this.preServiceAreas[item].title)
        }
      }
        this.companyForm.patchValue({
           ...data,
          // serviceAreas: this.serviceAreaName,
           owner: this.titleCaseOwnerNames(data.owner),
           focalPersonInformation: {
            ...data.focalPersonInformation,
            name: this.titleCase.transform(data?.focalPersonInformation?.name),
          },
           taxInformation: {
            ...data.taxInformation,
            name: this.titleCase.transform(data?.taxInformation?.name),
          },

           insurance: {
            ...data.insurance,
            generalLiabilityInsuranceDate: (data?.insurance?.generalLiabilityInsuranceDate) ? moment(data?.insurance?.generalLiabilityInsuranceDate).format('MM/DD/YYYY') : '',
            generalLiabilityInsuranceExpireDate: (data?.insurance?.generalLiabilityInsuranceExpireDate) ? moment(data?.insurance?.generalLiabilityInsuranceExpireDate).format('MM/DD/YYYY') : '',
            autoLiabilityInsuranceExpireDate: (data?.insurance?.autoLiabilityInsuranceExpireDate) ? moment(data?.insurance?.autoLiabilityInsuranceExpireDate).format('MM/DD/YYYY') : '',
            autoLiabilityInsuranceDate: (data?.insurance?.autoLiabilityInsuranceDate) ? moment(data?.insurance?.autoLiabilityInsuranceDate).format('MM/DD/YYYY') : '',
            workerCOIImageExpireDate: (data?.insurance?.workerCOIImageExpireDate) ? moment(data?.insurance?.workerCOIImageExpireDate).format('MM/DD/YYYY') : ''
          },
          documents: {
            ...data.documents,
            hIPAATrainingDate: (data?.documents?.hIPAATrainingDate )? moment(data?.documents?.hIPAATrainingDate).format('MM/DD/YYYY') : '',
            hIPAATrainingExpireDate: (data?.documents?.hIPAATrainingExpireDate) ? moment(data?.documents?.hIPAATrainingExpireDate).format('MM/DD/YYYY') : '',
            fraudWasteAndAbuseCertificateExpireDate: (data?.documents?.fraudWasteAndAbuseCertificateExpireDate )? moment(data?.documents?.fraudWasteAndAbuseCertificateExpireDate).format('MM/DD/YYYY') : '',
            fraudWasteAndAbuseCertificateDate: (data?.documents?.fraudWasteAndAbuseCertificateDate)? moment(data?.documents?.fraudWasteAndAbuseCertificateDate).format('MM/DD/YYYY') : ''
          },}),
          
          this.companyVarificationForm.patchValue({
            ...data.validationFlags,
            address: {
                ...this.companyVarificationForm.value.address,
                ...data.validationFlags?.address
            },
            owner: {
                ...this.companyVarificationForm.value.owner,
                ...data.validationFlags?.owner,
                address: {
                    ...this.companyVarificationForm.value.owner.address,
                    ...data.validationFlags?.owner?.address
                }
            },
            documents: {
                ...this.companyVarificationForm.value.documents,
                ...data.validationFlags?.documents
            },
            insurance: {
                ...this.companyVarificationForm.value.insurance,
                ...data.validationFlags?.insurance
            },
            bankDetails: {
                ...this.companyVarificationForm.value.bankDetails,
                ...data.validationFlags?.bankDetails
            }
        });
        if (data.hoursofOperation && data.hoursofOperation.length) {
            this.loadOperationHours(data.hoursofOperation);
        } else {
          this.loadOperationHours();
        }
        if (this.scrollToField) {
          scrollToDocumentField(this.scrollToField, 300, true, this.highlightStatus);
        }
      }
    })
  }

  checkNonValidFields() {
    const nonValidFields: string[] = [];
  
    const traverse = (obj: { [x: string]: any; }, path = "") => {
      for (const key in obj) {
        const value = obj[key];
        const currentPath = path ? `${path}.${key}` : key;
  
        if (!value) {
          nonValidFields.push(currentPath); // Store the full path of the invalid field
        }
  
        if (typeof value === "object" && value !== null) {
          traverse(value, currentPath); // Recurse for nested objects
        }
      }
    };
  
    traverse(this.companyData?.validationFlags);
    traverse(this.companyVarificationForm.value);
    return nonValidFields;
  }

  onSave() {

    if (this.companyVarificationForm.invalid) {
      return;
    }
    const payload = this.companyVarificationForm.value;
    this.verificationService.verifyCompany(this.companyId, payload).pipe(untilDestroyed(this)).subscribe((data:any) => {
      if (data) {
        this.companyData = data;
        this.patchValuesToForm(data)
      }
    })


  }

    onApproval() {
    this.submitted = true
    const isCurrentlyApproved = this.companyData?.isApproved;
    if(this.checkNonValidFields().length && !isCurrentlyApproved){
      sweetAlert('Alert', `Some fields are missing.`, 'warning', 'OK')
      return;
    }

    const newApprovalState = !isCurrentlyApproved;
    if (this.approvalForm.invalid) {
      return;
    }
    this.approvalForm.patchValue({
      isApproved:  newApprovalState
    })
    const payload = this.approvalForm.value;
    this.verificationService.approvedCompany(this.companyId, payload).pipe(untilDestroyed(this)).subscribe((data) => {
      if (data) {
        this.companyData = data;
        this.patchValuesToForm(data)
        // this.router.navigateByUrl('/credentials');
      }
    })
  }

  patchValuesToForm(data: any) {
    this.rejectedReasons = this.showRejectReason(data.rejectionReasons);
    delete data.hoursofOperation; // so that formarray is not replaced with normal array upon saving/approval
    this.companyForm.patchValue({
      ...data,
      owner: this.titleCaseOwnerNames(data.owner),
      focalPersonInformation: {
        ...data.focalPersonInformation,
        name: this.titleCase.transform(data?.focalPersonInformation?.name),
      },
      taxInformation: {
        ...data.taxInformation,
        name: this.titleCase.transform(data?.taxInformation?.name),
      },
      documents: {
        ...data.documents,
        hIPAATrainingDate: data?.documents?.hIPAATrainingDate ? moment(data?.documents?.hIPAATrainingDate).format('MM/DD/YYYY') : '',
        hIPAATrainingExpireDate: data?.documents?.hIPAATrainingExpireDate ? moment(data?.documents?.hIPAATrainingExpireDate).format('MM/DD/YYYY') : '',
        fraudWasteAndAbuseCertificateExpireDate: data?.documents?.fraudWasteAndAbuseCertificateExpireDate ? moment(data?.documents?.fraudWasteAndAbuseCertificateExpireDate).format('MM/DD/YYYY') : '',
        fraudWasteAndAbuseCertificateDate: data?.documents?.fraudWasteAndAbuseCertificateDate ? moment(data?.documents?.fraudWasteAndAbuseCertificateDate).format('MM/DD/YYYY') : ''
      },
       insurance: {
        ...data.insurance,
        generalLiabilityInsuranceDate: data?.insurance?.generalLiabilityInsuranceDate ? moment(data?.insurance?.generalLiabilityInsuranceDate).format('MM/DD/YYYY') : '',
        generalLiabilityInsuranceExpireDate: data?.insurance?.generalLiabilityInsuranceExpireDate ? moment(data?.insurance?.generalLiabilityInsuranceExpireDate).format('MM/DD/YYYY') : '',
        autoLiabilityInsuranceExpireDate: data?.insurance?.autoLiabilityInsuranceExpireDate ? moment(data?.insurance?.autoLiabilityInsuranceExpireDate).format('MM/DD/YYYY') : '',
        autoLiabilityInsuranceDate: data?.insurance?.autoLiabilityInsuranceDate ? moment(data?.insurance?.autoLiabilityInsuranceDate).format('MM/DD/YYYY') : '',
        workerCOIImageExpireDate: data?.insurance?.workerCOIImageExpireDate ? moment(data?.insurance?.workerCOIImageExpireDate).format('MM/DD/YYYY') : ''
      },
    });  

    this.approvalForm.patchValue(data);  
    this.companyVarificationForm.patchValue({
      ...data.validationFlags,
      address: {
          ...this.companyVarificationForm.value.address,
          ...data.validationFlags?.address
      },
      owner: {
          ...this.companyVarificationForm.value.owner,
          ...data.validationFlags?.owner,
          address: {
              ...this.companyVarificationForm.value.owner.address,
              ...data.validationFlags?.owner?.address
          }
      },
      documents: {
          ...this.companyVarificationForm.value.documents,
          ...data.validationFlags?.documents,
      },
      insurance: {
          ...this.companyVarificationForm.value.insurance,
          ...data.validationFlags?.insurance
      },
      bankDetails: {
          ...this.companyVarificationForm.value.bankDetails,
          ...data.validationFlags?.bankDetails
      }
  });
  
  }

  titleCaseOwnerNames(owner: any) {
    if (!owner) {
      return owner;
    }
    return {
      ...owner,
      firstName: this.titleCase.transform(owner.firstName),
      middleName: this.titleCase.transform(owner.middleName),
      lastName: this.titleCase.transform(owner.lastName),
    };
  }

  onDateChange(controlName: AbstractControl<any, any> | null) {
    onTimeChange(controlName)
  }

  getInvalidFields(): string[] {
    const formValues = this.companyVarificationForm.value;
    const labels: string[] = [];
    this.traverseForm(formValues, companyVerificationLabels, labels);
    return labels;
  }

  traverseForm(values: any, labelMap: any, labels: string[], prefix: string = ''): void {
    Object.keys(values).forEach(key => {
      if (typeof values[key] === 'object' && values[key] !== null) {
        // Check if labelMap[key] is an object, recursively call the function
        if (typeof labelMap[key] === 'object') {
          this.traverseForm(values[key], labelMap[key], labels, prefix);
        } else {
          this.traverseForm(values[key], labelMap[key], labels, prefix + labelMap[key] + ' - ');
        }
      } else if (values[key] === false) {
        labels.push(prefix + (labelMap[key] || key));
      }
    });
  }

  sendInvalidFieldsViaEmail(): void {
    const invalidFields = this.getInvalidFields();
    if (invalidFields.length > 0) {
      const payload = invalidFields;
      this.verificationService.informationViaEmail(this.companyId, invalidFields).pipe(untilDestroyed(this)).subscribe((data:any)=>{
        if(data){
        }
      })
  }
  
}


  getServiceAreas() {
    const queryParams = {
      limit: 9999,
      isActive: true,
    }
    this.serviceArea.getPicker(queryParams)
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data && data.results ) {
          this.serviceAreas = data.results;
          this.preServiceAreas = this.serviceAreas.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
           if (this.companyId) {
      this.getCompanybyId();
    }
          
        }
      })
  }

  


get approveForm() {
  return this.approvalForm.controls;
}

get operationsArray() {
  return this.companyForm.get('hoursofOperation') as FormArray;
}


  ngOnDestroy(): void { }
}
